import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonComponentModule } from '../common/common.module';
import { FormsModule } from '@angular/forms';
import { ImageCarouselTempModule } from '../common/image-carousel-temp/image-carousel-temp.module';
import { MediaCarouselModule } from '../common/media-carousel/media-carousel.module';



@NgModule({
  declarations: [MenuItemComponent],
  imports: [
    CommonModule,
    CommonComponentModule,
    FormsModule,
    ImageCarouselTempModule,
    MediaCarouselModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports:[MenuItemComponent]
})
export class MenuModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
